import { render, staticRenderFns } from "./SatsFooter.vue?vue&type=template&id=1191c1c2&scoped=true&"
var script = {}
import style0 from "./SatsFooter.vue?vue&type=style&index=0&id=1191c1c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1191c1c2",
  null
  
)

export default component.exports